import { has } from "lodash/object";

export let getToolTip = data => {
  let tooltip = "";
  if (has(data.units, "tooltip")) {
    tooltip = data.units.tooltip;
  } else {
    tooltip = data.tooltip;
  }
  return tooltip;
};
